import Hosts from '../../../Hosts';

const object_type = 'intranet/quality'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`

const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/type/${companycode}/forms_type`

const base_endpoint = '/forms_type'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        name: [],
        tag: '',
        link: '',
        image: {},
        color: {
            primary: '',
            primary_rgb: '',
            secondary: '',
        },
        order: 0,
        type: 'forms_type',
        companycode: '',

        avaiable: false,
        select_colab: false,
        poll_active: false,
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,

}